import { render, staticRenderFns } from "./LeaveRequestNew.vue?vue&type=template&id=60b63058"
import script from "./LeaveRequestNew.vue?vue&type=script&lang=js"
export * from "./LeaveRequestNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports